import React, { useState, useCallback, useMemo, memo } from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import ContentModal from "components/ContentModal";

function QuarterYearModal({ handleClose, gridData, onSubmit }) {
  const [loading, setLoading] = useState(false);

  const { filteredQuarters, filteredYears } = useMemo(() => {
    const pendingDecisionPolicies = gridData.filter(
      (policy) => policy.coding.status === "Pending Decision"
    );

    const uniqueQuarters = [
      ...new Set(pendingDecisionPolicies.map((p) => p.quarter)),
    ].sort();
    const uniqueYears = [
      ...new Set(pendingDecisionPolicies.map((p) => p.year)),
    ].sort();

    return { filteredQuarters: uniqueQuarters, filteredYears: uniqueYears };
  }, [gridData]);
  const [quarter, setQuarter] = useState(
    filteredQuarters.length === 1 ? filteredQuarters[0] : ""
  );
  const [year, setYear] = useState(
    filteredYears.length === 1 ? filteredYears[0] : ""
  );
  const handleSubmit = useCallback(async () => {
    setLoading(true);
    try {
      await onSubmit(quarter, year);
    } catch (error) {
      console.error("Submission failed:", error);
    } finally {
      setLoading(false);
    }
  }, [onSubmit, quarter, year]);

  return (
    <ContentModal
      maxWidth={"sm"}
      handleClose={handleClose}
      content={
        <Box display="flex" gap={2} sx={{ p: 1 }}>
          <FormControl sx={{ minWidth: 150, flex: 1 }}>
            <InputLabel id="quarter">Quarter</InputLabel>
            <Select
              id="quarter"
              label="Quarter"
              value={quarter}
              onChange={(e) => setQuarter(e.target.value)}
            >
              {filteredQuarters.map((q) => (
                <MenuItem key={q} value={q}>
                  {q}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: 150, flex: 1 }}>
            <InputLabel id="year">Year</InputLabel>
            <Select
              id="year"
              label="Year"
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              {filteredYears.map((y) => (
                <MenuItem key={y} value={y}>
                  {y}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      }
      actions={
        <Button
          disabled={!year || !quarter || loading}
          onClick={handleSubmit}
          startIcon={loading && <CircularProgress size={20} />}
        >
          {loading ? "Submitting..." : "Submit"}
        </Button>
      }
      title="CAB Year and Quarter"
      open
    />
  );
}

export default React.memo(QuarterYearModal);
